import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const ConfirmEmailChange = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading');
  const token = searchParams.get('token');

  useEffect(() => {
    const confirmChange = async () => {
      if (!token) {
        setStatus('error');
        toast.error('Invalid confirmation link');
        return;
      }

      try {
        await axios.post(`${API_URL}/users/confirm-email-change`, { token });
        setStatus('success');
        toast.success('Email changed successfully');
      } catch (error) {
        setStatus('error');
        toast.error(error.response?.data?.message || 'Failed to confirm email change');
      }
    };

    confirmChange();
  }, [token]);

  return (
    <div className="min-h-screen bg-[#040b24] text-blue-50 flex items-center justify-center p-8">
      <div className="w-full max-w-md rounded-2xl border border-blue-500/25 bg-[#0a1438] p-6 shadow-[0_24px_50px_rgba(0,0,0,0.45)]">
        <h1 className="text-2xl font-bold text-white">Confirm Email Change</h1>
        <p className="mt-2 text-sm text-blue-200/80">
          {status === 'loading' && 'Processing your confirmation link...'}
          {status === 'success' && 'Your account email has been updated.'}
          {status === 'error' && 'This link is invalid or expired.'}
        </p>

        <div className="mt-6 flex gap-3">
          <Link
            to="/signin"
            className="rounded-lg bg-blue-600 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-500"
          >
            Go to Sign In
          </Link>
          <button
            type="button"
            onClick={() => navigate('/dashboard')}
            className="rounded-lg border border-blue-400/35 px-4 py-2 text-sm font-semibold text-blue-100 hover:bg-blue-500/10"
          >
            Go to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmEmailChange;
